import {theme} from "../theme"

export const techIcons = [
    { name: "Bootstrap", img: "bootstrap.png", color: theme.iconColors[1] },
    { name: "CSS3", img: "css3.png", color: theme.iconColors[1] },
    { name: "Express", img: "express.png", color: theme.iconColors[1] },
    { name: "Git", img: "git.png", color: theme.iconColors[1] },
    { name: "GraphQL", img: "graphql.png", color: theme.iconColors[1] },
    { name: "HTML5", img: "html5.png", color: theme.iconColors[1] },
    { name: "Illustrator", img: "illustrator.png", color: theme.iconColors[1] },
    { name: "JavaScript", img: "javascript.png", color: theme.iconColors[1] },
    { name: "MongoDB", img: "mongodb.png", color: theme.iconColors[1] },
    { name: "Next.js", img: "nextjs.png", color: theme.iconColors[1] },
    { name: "Node.js", img: "node.png", color: theme.iconColors[1] },
    { name: "Photoshop", img: "photoshop.png", color: theme.iconColors[1] },
    { name: "React", img: "react.png", color: theme.iconColors[1] },
    { name: "Redux", img: "redux.png", color: theme.iconColors[1] },
    { name: "Tailwind CSS", img: "tailwindcss.png", color: theme.iconColors[1] },
    { name: "TypeScript", img: "typescript.webp", color: theme.iconColors[1] },
    { name: "VS Code", img: "vscode.webp", color: theme.iconColors[1] },
  ];
  